import styled from 'styled-components'
import { ButtonStyle } from 'Components/Shared/Button/ButtonStyle'

export const ChoosePlanStyle = styled.div`
  @media (max-width: 600px) {
    width: 99%;
  }
  
  ${ButtonStyle} {
    @media  (max-width: 600px) {
      width: 100% !important;
    }
    font-weight: bolder;
    font-size: 0.95em;
    white-space: nowrap;
    border-radius: 16px;
    color: ${(props) => props.theme.pcwCell?.buttonColor || '#ffffff'};
    background: ${(props) =>
      props.theme.pcwCell?.buttonBackground || '#E11870'};
  }
}`

export const PlanInfoStyle = styled.div`
  @media (max-width: 600px) {
    padding: 0.7em 1em;
    border-radius: 16px;
    background: #c0c0c0;
    color: white;
    width: 93%;
    text-decoration: none;
    font-size: small;
  }
  font-size: x-small;
  color: #000000;
  font-weight: normal;
  // text-decoration: underline;
  margin-top: 10px;
  cursor: pointer;
`
